import { createContext } from 'react';

interface OverflowMenuContextType {
    acceptFocus?: boolean;
    isWhite?: boolean;
}

export const OverflowMenuContext = createContext<OverflowMenuContextType>({});
